// extracted by mini-css-extract-plugin
export default {"root":"IconSelector_root__hcNXT","option":"IconSelector_option__LeN9y","preview":"IconSelector_preview__OmR-h"};